import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  fetchAttentionNoticeList,
  fetchInitialNoticeList,
  fetchMyNotice,
  fetchNotice,
  fetchNoticeList,
  initialState,
  MyhouseNoticeDetail,
  NoticeListParam,
  NoticeParam,
  updateNoticeCategory,
  updateNoticeDetail,
  updateNoticeSequence,
} from '@Root/slices/myhouse/notice'
import { RootState } from '@Root/slices'
import { MY_HOUSE_NOTICE_CATEGORY } from '@Root/contants/myhouse'

export default function useNotice() {
  const dispatch = useDispatch()
  const notice = useSelector((state: RootState) => state.notice)

  const setNoticeSequence = useCallback(
    (value: number) => {
      dispatch(updateNoticeSequence(value))
    },
    [dispatch],
  )

  const setNoticeCategory = useCallback(
    (category: MY_HOUSE_NOTICE_CATEGORY) => {
      dispatch(updateNoticeCategory(category))
    },
    [dispatch],
  )

  const loadAttentionNoticeList = useCallback(
    (param: NoticeListParam) => {
      dispatch(fetchAttentionNoticeList(param))
    },
    [dispatch],
  )

  const loadNoticeList = useCallback(
    (param: NoticeListParam) => {
      dispatch(fetchNoticeList(param))
    },
    [dispatch],
  )

  const loadInitialNoticeList = useCallback(
    (param: NoticeListParam) => {
      dispatch(fetchInitialNoticeList(param))
    },
    [dispatch],
  )

  const loadNotice = useCallback(
    (param: NoticeParam) => {
      dispatch(fetchNotice(param))
    },
    [dispatch],
  )

  const loadMyNotice = useCallback(
    (param: NoticeParam) => {
      dispatch(fetchMyNotice(param))
    },
    [dispatch],
  )

  const initializeNotice = useCallback(
    (detail?: Partial<MyhouseNoticeDetail>) => {
      dispatch(
        updateNoticeDetail({
          ...initialState.detail,
          ...detail,
        }),
      )
    },
    [dispatch],
  )

  return {
    notice,
    setNoticeSequence,
    setNoticeCategory,
    loadNotice,
    loadAttentionNoticeList,
    loadNoticeList,
    loadInitialNoticeList,
    loadMyNotice,
    initializeNotice,
  }
}
